import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class EditableComponent extends Vue {
    @Prop({ type: Boolean, default: false }) public editable: boolean;
    @Prop({ type: Boolean, default: false }) public loading: boolean;
}
